// L0 technical ceilings of the engine (RUNTIME-CONTRACT-V1.md §10.1).
//
// These are SAFETY limits of the InteractAds runtime/compiler (bounded
// memory, bounded validation time, bounded payloads). They are NOT platform
// (DSP) limits and NOT commercial limits: those are injected as a
// ResourcePolicy (policy.ts) and default to "not enforced" while OPEN.
// Values follow the existing Creative Content v1 caps where one exists.

export const ENGINE_LIMITS = {
  maxDocumentBytes: 262_144,
  maxDepth: 32,
  layouts: 16,
  formatKeysPerLayout: 8,
  scenes: 50,
  elements: 500,
  childrenPerContainer: 200,
  assets: 200,
  fonts: 16,
  links: 50,
  variables: 64,
  enumValues: 32,
  timers: 32,
  rules: 500,
  actionsPerRule: 50,
  actionsPerAfter: 20,
  afterNesting: 2,
  customEvents: 32,
  customEventProps: 4,
  customEventEnumValues: 20,
  customEventMaxPerInstance: 1_000,
  tracksPerElement: 16,
  keyframesPerTrack: 32,
  statesPerElement: 16,
  behaviorsPerElement: 4,
  tagsPerElement: 8,
  textRuns: 50,
  textRunLength: 2_000,
  shadows: 4,
  gradientStops: 8,
  polygonPoints: 256,
  pathLength: 20_000,
  exprNodes: 64,
  exprDepth: 8,
  cascadeDepth: 8,
  surveyQuestions: 200,
  surveyOptions: 20,
  forms: 8,
  fieldsPerForm: 32,
  fieldOptions: 50,
  canvasMax: 4_096,
  coordinateMax: 100_000,
  durationMaxMs: 600_000,
  timerMinMs: 100,
  timerTickMinMs: 250,
  spawnPoolMax: 50,
  urlLength: 2_048,
  // Advergaming module (7.6F, ADR-0022).
  gameScenes: 10,
  gameTargets: 50,
  gamePairs: 12,
  gameDropItems: 16,
  gameDropZones: 16,
  // Runner / platformer (7.6F.1, ADR-0023): bounded so one step of the
  // simulation does at most runnerActiveMax + runnerItems hit tests.
  runnerSegments: 8,
  runnerSceneryPerSegment: 16,
  runnerLayers: 6,
  runnerItems: 16,
  runnerSpawns: 8,
  runnerTemplatesPerSpawn: 4,
  /** Spawned instances alive at once across every spawn rule (sum of maxActive). */
  runnerActiveMax: 24,
  /** Shortest interval between two spawns of one rule (no zero-interval spawn loops). */
  runnerSpawnMinMs: 250,
  runnerSpeedMin: 20,
  runnerSpeedMax: 1_200,
  runnerJumpMinMs: 200,
  runnerJumpMaxMs: 3_000,
  // Runtime execution budget (INTERACTION-MODEL §8.4): one logical interaction
  // (an input, a timer, a scheduled instant) executes at most this many actions;
  // the rest is cut and reported (runtime_error RULE_BUDGET). Never infinite.
  actionsPerInteraction: 1_000,
  /** Deferred (`after`) actions pending at once per instance. */
  pendingActions: 256,
} as const;

/** SURVEY-ENGINE.md §4: product rule, not configurable upwards. */
export const SURVEY_MAX_QUESTIONS_PER_PATH = 8;
/** SURVEY-ENGINE.md §4 guidance (WARNING only): 6 research + 2 demographic. */
export const SURVEY_GUIDANCE = { research: 6, demographic: 2 } as const;
